"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing Profile operations. */
var ProfileImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class Profile class.
   * @param client Reference to the service client
   */
  function ProfileImpl(client) {
    (0, _classCallCheck2["default"])(this, ProfileImpl);
    this.client = client;
  }
  /**
   *  (Auth: Authorize)
   * @param portalId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(ProfileImpl, [{
    key: "getSavedSearchQueriesForCurrentUser",
    value: function getSavedSearchQueriesForCurrentUser(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getSavedSearchQueriesForCurrentUserOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "addSavedSearchQuery",
    value: function addSavedSearchQuery(portalId, body, options) {
      var operationArguments = {
        portalId: portalId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, addSavedSearchQueryOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param queryId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "updateSavedSearchQuery",
    value: function updateSavedSearchQuery(portalId, queryId, body, options) {
      var operationArguments = {
        portalId: portalId,
        queryId: queryId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, updateSavedSearchQueryOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param queryId
     * @param options The options parameters.
     */

  }, {
    key: "deleteSavedSearchQuery",
    value: function deleteSavedSearchQuery(portalId, queryId, options) {
      var operationArguments = {
        portalId: portalId,
        queryId: queryId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, deleteSavedSearchQueryOperationSpec);
    }
  }]);
  return ProfileImpl;
}(); // Operation Specifications


exports.ProfileImpl = ProfileImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getSavedSearchQueriesForCurrentUserOperationSpec = {
  path: "/api/portals({portalId})/profile/searches",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SavedSearchQueryViewModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var addSavedSearchQueryOperationSpec = {
  path: "/api/portals({portalId})/profile/searches",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.SavedSearchQueryViewModel
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body21,
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var updateSavedSearchQueryOperationSpec = {
  path: "/api/portals({portalId})/profile/searches/{queryId}",
  httpMethod: "PUT",
  responses: {
    200: {
      bodyMapper: Mappers.SavedSearchQueryViewModel
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body21,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.queryId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var deleteSavedSearchQueryOperationSpec = {
  path: "/api/portals({portalId})/profile/searches/{queryId}",
  httpMethod: "DELETE",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.queryId],
  serializer: serializer
};